import { NoDataFoundError } from '../APIRequestError';
import { handleSentryErrors } from '../HandleSentryErrors';
import { postRequest as post } from '../HttpMethods';

interface CreateEntityParams<T> {
  path: string;
  entity: T;
  isEntity?: (obj: any) => obj is T;
  functionName: string;
}

export const createEntity = async <T>({
  path,
  entity,
  functionName,
}: CreateEntityParams<T>): Promise<T | null> => {
  const data = await post('QBilling', path, entity);
  const parsedData = await data;
  if (!parsedData || !Object.keys(parsedData).length) {
    const error = new NoDataFoundError('No Data Found', functionName, path);
    handleSentryErrors({
      error: error,
      displayNotification: false,
      functionName: functionName,
      params: path,
    });
  }

  return parsedData as T;
};
